export default function createFieldRule (identifier, type, promptText) {
  return {
    identifier: identifier,
    rules: [{
      type: type,
      prompt: promptText
    }]
  }
}
